import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import endpoints from '../../../shared/constants/endpoints';
import { buildListSearch } from '../helpers';

const linkClass = 'px-5 py-2 rounded-full border-2 border-dark dark:border-white font-montserratBold hover:bg-dark hover:text-white';

const NewsPagination = ({ currentPage, lastPage, query }) => {
  if (lastPage <= 1) {
    return null;
  }

  const pageLink = page => ({ pathname: endpoints.news, search: buildListSearch({ q: query, page }) });

  return (
    <nav aria-label="Newsroom pages" className="flex items-center justify-center gap-6 mt-12 text-dark dark:text-white">
      {currentPage > 1 ? (
        <Link to={pageLink(currentPage - 1)} className={linkClass} data-part="news-pill" rel="prev">Newer</Link>
      ) : <span />}
      <span className="font-montserratMedium">
        Page 
        {' '}
        {currentPage}
        {' '}
of 
        {' '}
        {lastPage}
      </span>
      {currentPage < lastPage ? (
        <Link to={pageLink(currentPage + 1)} className={linkClass} data-part="news-pill" rel="next">Older</Link>
      ) : <span />}
    </nav>
  );
};

NewsPagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  lastPage: PropTypes.number.isRequired,
  query: PropTypes.string,
};

NewsPagination.defaultProps = {
  query: '',
};

export default NewsPagination;
